<div class="d-flex flex-row h-100 flex-wrap">
  <lib-prod-grid style="flex: 1; width: 100%"
                 [title]="prodGridTitle"
                 [icon]="'dataset'"
                 [class]="'company-lower'"
                 [columns]="prodGridColumns"
                 [isAddButtonShown]="true"
                 [isAddButtonDisabled]="prodGridToolbarButtonsStatus.isAddButtonDisabled.disabled"
                 [isEditButtonShown]="true"
                 [isRemoveButtonShown]="true"
                 [isRemoveButtonDisabled]="prodGridToolbarButtonsStatus.isRemoveButtonDisabled.disabled"
                 [headerButtons]="prodGridHeaderButtons"
                 [limitless]="true"
                 [matTableDataSource]="matTableDataSource"
                 [inputAction$]="inputAction$"
                 [rowClasses]="rowClasses"
                 (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
  <lib-prod-header [title]="siteMapTitle" [icon]="'map'" [class]="'company-lower'" style="flex: 1; height: 100%">
    <lib-prod-map
      [markers$]="gridMapService.markers$"
      [markerSelected$]="gridMapService.markerSelected$"
      [mapName]="'siteMap'"
      [mapFilter$]="gridMapService.mapFilter$"
      [mapBounds$]="gridMapService.mapBounds$"
      (prodMapEvents$)="prodMapEvents($event)"></lib-prod-map>
  </lib-prod-header>
</div>
